import { isPrerenderPath } from './prerender-paths';
import type { Lang } from './i18n-core';

export function canHydratePrerender({
  hasSsr,
  ssrLang,
  currentLang,
  path,
}: {
  hasSsr: boolean;
  ssrLang: Lang;
  currentLang: Lang;
  path: string;
}): boolean {
  return hasSsr && ssrLang === currentLang && isPrerenderPath(path);
}
